"use client";
import { useContext } from "react";
import EmblaSliderContext from "./EmblaSliderContext";

const useEmblaSlider = () => useContext(EmblaSliderContext);

export default useEmblaSlider;
